/**
 * 数组转换对象
 * 如果数组的子元素不为Object，则过滤
 *
 * @param {array} arr
 * @param {object} arr.item
 * @returns {object}
 */
export default function arrTransformObj(arr, field) {
    arr = arr || [];
    return arr.reduce(function (pre, next) {
        if (Object.prototype.toString.call(next) !== '[object Object]')
            return pre;
        pre[next[field]] = next;
        return pre;
    }, {});
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/utils/arrTransformObj.js
// module id = null
// module chunks = 